import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getPaymentConfirmURL, getPaymentTestURL, getPaymentURL, getStatisticsURL } from '../api';
import moment from 'jalali-moment'
import Num2persian from 'num2persian';
import { addComma } from "../helpers/mmg";
import { errors } from "monopay/dist/drivers/behpardakht/api";
// initial state
export const initialState = {

  loading: false,
  error: false,
  errorMessage : '',
  postRefId : 0,
  amount : 0,
  amountInWord : 'مبلغ جهت شارژ حساب',
  paymentVerificationState : 0 ,//صفر یعنی پیش فرض. یک یعنی انجام شد با موفقیت و دو یعنی خطا در تایید پرداخت
  paymentVerificationNumber : ''
};

// our slice
const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPaymentLoading: (state) => {
      state.loading = true;
    },
    setPostRefId: (state, { payload }) =>{
      state.loading = false;
      state.postRefId = payload;
    },
    setAmount: (state, { payload }) =>{
      state.amount = addComma(payload);
      state.amountInWord = Num2persian(parseInt(payload / 10)) + " تومان ";
    },
    setPaymentVerificationState: (state, { payload }) =>{

      console.log("payload is   sis iis ");
      console.log(payload);
      state.loading = false;
      state.paymentVerificationState = payload.state;
      state.paymentVerificationNumber =  payload.number;
    },
    setPaymentError: (state, { payload }) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = payload;
    },
    clearPayment: (state) => {
      state.loading= false;
      state.error = false;
      state.errorMessage = "";
      state.postRefId = 0;
      state.amount = 0;
      state.amountInWord = "مبلغ جهت شارژ حساب";
      state.paymentVerificationState = 0;
      state.paymentVerificationNumber = "";
    },
  },
});

// export the actions
export const { setPaymentLoading, setPostRefId, setAmount , setPaymentError, clearPayment, setPaymentVerificationState} = paymentSlice.actions;


// export the default reducer
export default paymentSlice.reducer;


// fetch all items
export function fetchPayment(input) {
  return async (dispatch) => {
    
    localStorage.removeItem('oldPosRefId');
    localStorage.removeItem('oldOrderId');
    localStorage.removeItem('amount');

    dispatch(setPaymentLoading());

    //dispatch(setStatisticsLoading());

    await axios.post(getPaymentTestURL()+'?type=0&orderId=165&amount=100000&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {

          console.log(response.data);
          
          dispatch(setPostRefId(response.data));
         
          localStorage.setItem('oldPosRefId', response.data);
          localStorage.setItem('oldOrderId', input.orderId);
          localStorage.setItem('amount', input.amount);

          postRefId(response.data);

      }).catch(function (err) {
        console.log(err);
        console.log(errors[err.response.data]);
        
        dispatch(setPaymentError(err.message + '  ' + err.response.data + ' ' + errors[err.response.data]));
      }).finally(()=> {

      });
  
  };
}

export function confirmPaymentandGenerateReceipt(input) {
  return async (dispatch) => {
    

    console.log("The Input");
    console.log(input);

    dispatch(setPaymentLoading());

    let chequeItems = [];
    let draftItems = [];
    let posItems = [];

    draftItems.push(
    {
      Number : input.Number,
      Amount : input.Amount.toString().replaceAll(',',''),
      Date : input.Date ,//moment.from(input.Date, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10),
      Description : input.ItemDescription,
      BankAccountId : 0,
      CurrencyId : input.CurrencyId
    });
      

    let receipt = {};
    receipt = {
      Number: null,
      Date : input.Date,
      SLId : 0,
      DLId : null,
      PartyId : input.authUser.partyId,
      Description : input.Description,
      CashId : null,
      Amount : 0,
      Discount : 0,
      CurrencyId : input.CurrencyId,
      ReceiptCheques: chequeItems,
      ReceiptDrafts: draftItems,
      ReceiptPoses: posItems,
      ProposedInvoice : null
    
    }


    var data = JSON.stringify(receipt);

    console.log("data");
    console.log(data);

    var config = {
      method: 'post',
      url: `${getPaymentConfirmURL()}?oldOrderID=${localStorage.getItem('oldOrderId')}&orderId=${input.SaleOrderId}&saleRefId=${input.SaleReferenceId}&username=${input.authUser.username}&password=${encodeURIComponent(input.authUser.password)}&token=${input.authUser.token}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    await axios(config)
    .then(function (response) {
       

        console.log("response.data");
        console.log(response.data);
        if(response.data.ID > 0 ){
          dispatch(setPaymentVerificationState({ number : input.SaleReferenceId , state : 1 }));
        }else{
          dispatch(setPaymentVerificationState({ number : '' , state : 2 }));
        }
         

      }).catch(function (err) {
        console.log("response.data");
        console.log(err);
        dispatch(setPaymentVerificationState(2));
        dispatch(setPaymentError(err.message + '  ' + err.response.data + ' ' + errors[err.response.data]));

      }).finally(()=> {

      });
  
  };
}


export const postRefId = (refIdValue) => {
  var form = document.createElement("form");
  form.setAttribute("method", "POST");
  form.setAttribute("action", "https://bpm.shaparak.ir/pgwchannel/startpay.mellat");
  form.setAttribute("target", "_self");
  var hiddenField = document.createElement("input");
  hiddenField.setAttribute("name", "RefId");
  hiddenField.setAttribute("value", refIdValue);
  form.appendChild(hiddenField);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}